
// Simple Carousel Arrow Hide/Show Script
// Hide arrows when carousel is at the beginning or end

function setupCarouselArrows() {
    // Find the carousel container
    const carousel = document.querySelector('[data-tolstoy-element="tolstoy-carousel-videos-container-qh6cv17a5uhhp"]');

    if (!carousel) {
        return;
    }

    // Get the arrow elements
    const leftArrow = document.querySelector('.tolstoy-previous-button');
    const rightArrow = document.querySelector('.tolstoy-next-button');

    if (!leftArrow || !rightArrow) {
        return;
    }

    // Check carousel position and hide/show arrows
    function updateArrows() {
        // Get all carousel tiles
        const tiles = carousel.querySelectorAll('[data-tolstoy-tile-key]');

        if (tiles.length === 0) return;

        // Find which tile is in the center (translateX = 0)
        let centerIndex = -1;
        tiles.forEach((tile, index) => {
            const transform = tile.style.transform;
            if (transform.includes('translateX(0px)')) {
                centerIndex = index;
            }
        });

        // Check if we're at start or end
        const isAtStart = centerIndex === 0;
        const isAtEnd = centerIndex === tiles.length - 1;

        // Hide/show left arrow
        leftArrow.style.opacity = isAtStart ? '0' : '1';
        leftArrow.style.pointerEvents = isAtStart ? 'none' : 'auto';

        // Hide/show right arrow
        rightArrow.style.opacity = isAtEnd ? '0' : '1';
        rightArrow.style.pointerEvents = isAtEnd ? 'none' : 'auto';
    }

    // Watch for changes in carousel
    const observer = new MutationObserver(() => {
        setTimeout(updateArrows, 100);
    });

    observer.observe(carousel, {
        attributes: true,
        subtree: true,
        attributeFilter: ['style']
    });

    // Initial check
    updateArrows();

    return { updateArrows, destroy: () => observer.disconnect() };
}


window.addEventListener('tolstoyWidgetReady', setupCarouselArrows);
